import { render, staticRenderFns } from "./SelectedItemDisplay.vue?vue&type=template&id=7f26140a"
import script from "./SelectedItemDisplay.vue?vue&type=script&lang=js"
export * from "./SelectedItemDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports